import axios, { type AxiosInstance } from 'axios';
import type { LoginOption } from '../../domain/entities/auth.entity';

export type VerifyResult =
  | { status: 'resolved'; institution: string; courseId: string; description: string }
  | { status: 'ambiguous'; options: LoginOption[] }
  | { status: 'invalid' };

// Instância própria, sem os interceptors do apiClient — a verificação roda
// antes de existir sessão salva, então não deve disparar o toast/modal de
// "credenciais inválidas" nem depender de institution/courseId já resolvidos.
const client: AxiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
});

export class AuthApiDatasource {
  // GET /session só resolve a identidade do login via basicAuth — não faz
  // nenhuma consulta de negócio, existe só pra essa verificação.
  // `institution` opcional: sem ele, o basicAuth busca em TODAS as
  // institutions — é como a tela de seleção mostra listas de outras
  // instituições (ex.: ARISTO) mesmo entrando pela URL de uma instituição
  // parceira (ex.: FAG), quando o mesmo login tem acesso às duas.
  async verify(
    token: string,
    institution?: string,
    courseId?: string,
  ): Promise<VerifyResult> {
    try {
      const { data } = await client.get<{
        institution: string;
        courseId: string;
        description?: string;
      }>('/v1/mockexamperformancedashboard/session', {
        headers: { Authorization: token },
        params: { institution, courseId },
      });
      return {
        status: 'resolved',
        institution: data.institution,
        courseId: data.courseId,
        description: data.description || data.institution,
      };
    } catch (err) {
      if (axios.isAxiosError(err) && err.response?.status === 400) {
        const options = err.response.data?.options;
        if (Array.isArray(options) && options.length > 0) {
          return { status: 'ambiguous', options };
        }
      }
      return { status: 'invalid' };
    }
  }
}
